import {
  Shield, Database, Cloud, Settings, HeartPulse, Monitor,
  Wrench, Layers, Zap, Lock, Server, Headphones,
  TrendingUp, Award, Star, ChevronRight,
  ShieldCheck, Gem, Lightbulb, Target, Eye,
  Heart, GraduationCap, Users,
  Building2, Handshake, Scale,
  CheckCircle, MapPin, Clock, Briefcase, Send,
  Mail, Phone, Globe, ArrowRight, FileText,
} from 'lucide-react';

const ICON_MAP = {
  Shield, Database, Cloud, Settings, HeartPulse, Monitor,
  Wrench, Layers, Zap, Lock, Server, Headphones,
  TrendingUp, Award, Star, ChevronRight,
  ShieldCheck, Gem, Lightbulb, Target, Eye,
  Heart, GraduationCap, Users,
  Building2, Handshake, Scale,
  CheckCircle, MapPin, Clock, Briefcase, Send,
  Mail, Phone, Globe, ArrowRight, FileText,
};

/**
 * Resolve an icon name (string) to a lucide-react component.
 * If `name` is already a component (legacy default data), it is returned as-is.
 * Falls back to `fallback` (defaults to ChevronRight) when the name is unknown.
 */
export function resolveIcon(name, fallback = ChevronRight) {
  if (!name) return fallback;
  if (typeof name === 'function') return name; // already a component
  return ICON_MAP[name] || fallback;
}
